import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import HomepageHighlightedMember from './HomepageHighlightedMember'; // @ts-expect-error ts-migrate(7016) NOFIX

import avatarImage from 'bender-url!../../../../images/highlightedMembers/katherine-boyarsky.png';
export default function KatherineBoyarsky({
  avatarSize
}) {
  return /*#__PURE__*/_jsx(HomepageHighlightedMember, {
    displayName: "Katherine Boyarsky",
    roleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.homepage.memberHighlight.members.katherineBoyarsky.role"
    }),
    avatarSrc: avatarImage,
    avatarSize: avatarSize
  });
}